import { FormProvider, useForm } from "react-hook-form";

import ModalOutlet from "@/components/modals/router/ModalOutlet";

export interface TopUpForm {
  amount: string;
}

const TopUpWrap = () => {
  const settings = useForm<TopUpForm>();

  return (
    <FormProvider {...settings}>
      <ModalOutlet />
    </FormProvider>
  );
};

export default TopUpWrap;
